import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AppLayout } from '../components/layout/AppLayout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { LoadingSpinner } from '../components/ui/LoadingSpinner';

export default function CreditsSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Verifica se veio do Stripe (tem session_id) ou se é acesso direto
    if (!sessionId) {
      // Se não tem session_id, pode ser acesso direto ou redirecionamento incorreto
      // Redireciona para a página de créditos após um delay
      const timer = setTimeout(() => {
        navigate('/dashboard/credits', { replace: true });
      }, 2000);
      return () => clearTimeout(timer);
    }

    // Simula um pequeno delay para garantir que o webhook processou
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [sessionId, navigate]);

  const handleGoToCredits = () => {
    navigate('/dashboard/credits', { replace: true });
  };

  // Se não tem session_id, mostra loading e redireciona
  if (!sessionId) {
    return (
      <AppLayout>
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="text-center">
            <LoadingSpinner size="lg" />
            <p className="mt-4 text-gray-400">Redirecionando...</p>
          </div>
        </div>
      </AppLayout>
    );
  }

  if (loading) {
    return (
      <AppLayout>
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="text-center">
            <LoadingSpinner size="lg" />
            <p className="mt-4 text-gray-400">Processando pagamento...</p>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="max-w-2xl mx-auto">
        <Card className="p-8 text-center">
          <div className="mb-6">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-500/20 mb-4">
              <svg
                className="w-8 h-8 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h1 className="text-3xl font-bold mb-2">Pagamento Realizado com Sucesso!</h1>
            <p className="text-gray-400">
              Seus créditos foram adicionados à sua conta.
            </p>
            <p className="text-sm text-gray-500 mt-2">
              ID da Sessão: {sessionId}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button onClick={handleGoToCredits} size="lg">
              Ver Meus Créditos
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/dashboard', { replace: true })}
              size="lg"
            >
              Ir para Dashboard
            </Button>
          </div>
        </Card>
      </div>
    </AppLayout>
  );
}

